import { render } from "./contareceber-editar.vue?vue&type=template&id=6f4b0ade"
import script from "./contareceber-editar.vue?vue&type=script&lang=js"
export * from "./contareceber-editar.vue?vue&type=script&lang=js"

import "./contareceber-editar.vue?vue&type=style&index=0&id=6f4b0ade&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__